export default {"src":"/_next/static/media/symbol-icon-charity.31ac8af0.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};